import { NextRouter, useRouter } from "next/router";
import { useEffect } from "react";
import { useAuthStore } from "../stores/auth.store";

export const useRequireAuth = () => {
  const token = useAuthStore((state) => state.token);
  const router = useRouter();
  useEffect(() => {
    // console.log("token :", token);
    // console.log("router.pathname :", router.pathname);
    if (!token && router.pathname.indexOf("login") === -1) {
      authRedirect(router);
    }
  }, [token, router]);
};
export function authRedirect(router: NextRouter) {
  const path = encodeURIComponent(router.asPath);
  router.replace(`/login?redirect=${path}`);
}
